import { apiConfig } from 'config';
import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';

export function getRasterSettings() {
  let url = apiConfig.cmServiceGetRasterSettings;
  return fetchdata(url, { method: 'GET' }).catch((e) => {
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}
